import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button'
import classes from './AddPerfume.module.css';
import { useState, useEffect } from "react";
import db from "../../data/firebase";
import {Redirect, useHistory} from 'react-router-dom';
import AddImages from "./AddImages";
import Spinner from 'react-bootstrap/Spinner';

function AddPerfume(){

  
    let newPerfume={
        name: null,
        gender: null,
        desc: null,
        occasion: null,
        season: null,
        images: [],
        priceAndBottle:[],
        topNote: null,
        middleNote: null,
        baseNote: null,

    };

    let currentBottle=null;
    let currentprice=null;
    let currentImage=null;

    let imageCounter=0;

    let history= useHistory();
    function getName(event){
        newPerfume.name=event.target.value
        
    }
    function getDesc(event){
        newPerfume.desc=event.target.value
        
    }
    function getOccasion(event){
        newPerfume.occasion=event.target.value
        
    }
    function getSeason(event){
        newPerfume.season=event.target.value
        
    }
    function getGender(event){
        newPerfume.gender=event.target.value
        
    }
   
    function getImages(event){
        currentImage=event.target.value;
        // newPerfume.images[newPerfume.images.length]=event.target.value
    }

    function getBottle(event){
        
        currentBottle=event.target.value;
        
    }

    function getPrice(event){
    
        currentprice=event.target.value;
       
    }

    // Notes

    function getTopNote(event){
        
        newPerfume.topNote=event.target.value;
        
    }

    function getMiddleNote(event){
        
        newPerfume.middleNote=event.target.value;
        
    }

    function getBaseNote(event){
        
        newPerfume.baseNote=event.target.value;
        
    }

    function confirmBottleAndPrice(){
        if(currentBottle && currentprice){
            newPerfume.priceAndBottle[newPerfume.priceAndBottle.length]={
                bottle: currentBottle,
                price: currentprice,
            }
        }
        currentBottle=null;
        currentprice=null;
        console.log(newPerfume.priceAndBottle);

    }

    function resetBottleAndPrice(){
        currentBottle=null;
        currentprice=null;

    }

    
       
    



    function make(){
        newPerfume.images[newPerfume.images.length]=currentImage;

        if(newPerfume.priceAndBottle.length == 0){
            newPerfume.priceAndBottle[newPerfume.priceAndBottle.length]={
                bottle: "xx",
                price: "yyyy",
            }

        }
      
        db.collection('perfumes').add(
            newPerfume
        )

        history.push("/products");
      

    }



    

    
    

    return(


        <div className={classes.box}>
            
            <h3>Add Perfume</h3>
           
            <form>
                {/* name */}
               
                    <label className={classes.title}>Name:</label>
                <div>
                    <input required onChange={getName} className={classes.info} type="text" placeholder="Perfume Name"/>
                </div>
                
               

                {/* Description */}
                
                    <label className={classes.title}>Description:</label>
                <div>
                    <textarea onChange={getDesc}   className={classes.info}  placeholder="Description"/>
                </div>
               
                
                {/* Gender */}
              
                    <label className={classes.title}>Gender: </label>
                 <div >
                    <input required onChange={getGender} type="radio" id="male" name="gender" value="male"/>
                    <label className={classes.radio}  for="male">Male</label>
                    <input required onChange={getGender} type="radio" id="female" name="gender" value="female"/>
                    <label className={classes.radio} for="female">Female</label>
                    <input required  onChange={getGender} type="radio" id="unisex" name="gender" value="unisex"/>
                    <label className={classes.radio} for="unisex">Unisex</label>
                </div>
               

                {/* season */}
                
                    <label className={classes.title}>Season:</label>
                <div>
                    <input onChange={getSeason} className={classes.info} type="text" placeholder="Season"/>
                </div>
               

                 {/* occasion */}
                 
                     <label className={classes.title}>Occasion:</label>
                     <div>
                    <input onChange={getOccasion}  className={classes.info} type="text" placeholder="Occasion"/>
                </div>

                {/* Notes */}

                
                <label className={classes.title}>Top note:</label>
                <div>
                    <input onChange={getTopNote} className={classes.info} type="text" placeholder="Top note"/>
                </div>

                
                <label className={classes.title}>Middle note:</label>
                <div>
                    <input onChange={getMiddleNote} className={classes.info} type="text" placeholder="Middle note"/>
                </div>

                
                <label className={classes.title}>Base Note:</label>
                <div>
                    <input onChange={getBaseNote} className={classes.info} type="text" placeholder="Base note"/>
                </div>
                



                {/* price and bottle */}

                <label className={classes.title}>Bottle size and price:</label>
                <div>
                    <input required onChange={getBottle}  className={classes.info} type="text" placeholder="Bottle ml"/>
                    <input  required onChange={getPrice}  className={classes.info} type="text" placeholder="price"/>
               <div>
                   
                        <input required onChange={confirmBottleAndPrice} type="radio" id="done" name="select" value="done"/>
                        <label className={classes.radio}  for="done">Done</label>
                       
               </div>
                    
                </div>

                <label className={classes.title}>Bottle size and price:</label>
                <div>
                    <input onChange={getBottle}  className={classes.info} type="text" placeholder="Bottle ml"/>
                    <input onChange={getPrice}  className={classes.info} type="text" placeholder="price"/>
                    <div>
                   
                            <input onChange={confirmBottleAndPrice} type="radio" id="done" name="select" value="done"/>
                            <label className={classes.radio}  for="done">Done</label>
                          
               </div>
                </div>

                <label className={classes.title}>Bottle size and price:</label>
                <div>
                    <input onChange={getBottle}  className={classes.info} type="text" placeholder="Bottle ml"/>
                    <input onChange={getPrice}  className={classes.info} type="text" placeholder="price"/>
                    <div>
                   
                        <input onChange={confirmBottleAndPrice} type="radio" id="done" name="select" value="done"/>
                        <label className={classes.radio}  for="done">Done</label>
                        {/* <input onChange={resetBottleAndPrice} type="radio" id="undo" name="select" value="undo"/>
                        <label className={classes.radio} for="undo">Undo</label> */}
                    </div>
                </div>

                <label className={classes.title}>Bottle size and price:</label>
                <div>
                    <input onChange={getBottle}  className={classes.info} type="text" placeholder="Bottle ml"/>
                    <input onChange={getPrice}  className={classes.info} type="text" placeholder="price"/>
                    <div>
                   
                        <input onChange={confirmBottleAndPrice} type="radio" id="done" name="select" value="done"/>
                        <label className={classes.radio}  for="done">Done</label>
                     
              </div>
                </div>





                {/* ask images */}
                {/* <label className={classes.title}>How Many Images:</label>
                     <div>
                    <input onChange={getImageNumber} className={classes.info} type="number" placeholder="#"/>
                </div> */}

            


                {/* images */}
                <label className={classes.title}>Add image:</label>
                     <div>
                    <input onChange={getImages} className={classes.info} type="text" placeholder="image"/>
                </div>
{/* 
                <label className={classes.title}>Add image:</label>
                     <div>
                    <input onChange={getImages} className={classes.info} type="text" placeholder="image"/>
                </div>

                <label className={classes.title}>Add image:</label>
                     <div>
                    <input onChange={getImages} className={classes.info} type="text" placeholder="image"/>
                </div>

                <label className={classes.title}>Add image:</label>
                     <div>
                    <input onChange={getImages} className={classes.info} type="text" placeholder="image"/>
                </div> */}

             

                
             
                
           
               

            <button className={classes.submitButton} onClick={make}>Submit</button>

                
                
            </form>

            
            



       
       </div>
    )
}


export default AddPerfume;   